import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';

import {
    GetDateString,
    MinutesPassed
} from './other/DateFunctions';
import {
    GetDistance,
    GetTripDistance
} from './other/GeoFunctions';
import React, { createContext } from 'react';
import {
    acceptTask,
    bookingReq,
    cancelTask,
    fetchTasks
} from './actions/taskactions';
import {
    addBooking,
    addRentalBooking,
    clearBooking,
    editBooking,
} from './actions/bookingactions';
import {
    addCarType,
    deleteCarType,
    editCarType,
    fetchCarTypes
} from './actions/cartypeactions';
import {
    addDriverStatus,
    editDriverStatus,
    fetchDriverStatus,
    filterDriverStatus
} from './actions/driverstatusaction';
import {
    addLocalFare,
    addOutstationFare,
    addRentalFare,
    clearFare,
    fetchFare,
    updateFare
} from './actions/fareactions';
import {
    addOperator,
    deleteOperator,
    editOperator,
    fetchOperators
} from './actions/operatoractions';
import {
    addToWallet,
    clearMessage,
    fetchPaymentMethods,
    updateWalletBalance
} from './actions/paymentactions';
import {
    addTransaction,
    deleteTransaction,
    editTransaction,
    fetchTransactions
} from './actions/transactionactions';
import {
    addUser,
    editUser,
    fetchDrivers,
    fetchUsers,
    uploadImage,
    deleteUser,
} from './actions/usersactions';
import {
    addVehicle,
    deleteVehicle,
    driverEditVehicle,
    editVehicle,
    fetchVehicles,
    updateVehicleCommission
} from './actions/vehicleactions';
import {
    appleSignIn,
    checkOperatorExists,
    checkOtp,
    checkUserExists,
    checkVehicleExists,
    clearLoginError,
    // deleteUser,
    emailSignUp,
    facebookSignIn,
    fetchUser,
    mobileCheckOtp,
    mobileSignIn,
    mobileSignUp,
    mobileUserCreate,
    monitorProfileChanges,
    requestPhoneOtpDevice,
    sendResetMail,
    signIn,
    signOut,
    updateDriverStatus,
    updatePassword,
    updateProfile,
    updateProfileImage,
    updatePushToken,
    validateReferer,
    resetPassword
} from './actions/authactions';
import {
    cancelBooking,
    driverCancelBooking,
    fetchAllBookings,
    fetchBookings,
    updateBooking,
    fetchRequestedDrivers,
    getTrackingRecord
} from './actions/bookinglistactions';
import {
    clearDriverEstimate,
    clearEstimate,
    clearRentalEstimate,
    getDriverEstimate,
    getEstimate,
    getRentalEstimate,
} from './actions/estimateactions';
import {
    clearSettingsViewError,
    editSettings,
    fetchSettings
} from './actions/settingsactions';
import {
    clearTripPoints,
    updatSelPointType,
    updateTripCar,
    updateTripDrop,
    updateTripPickup
} from './actions/tripactions';
import {
    completeWithdraw,
    fetchWithdraws
} from './actions/withdrawactions';
import {
    editCancellationReason,
    fetchCancelReasons,
    addCancellationReason,
    deleteCancellationReason
} from './actions/cancelreasonactions';
import {
    addNotifications,
    deleteNotifications,
    editNotifications,
    fetchNotifications,
    sendNotification
} from './actions/notificationactions';
import {
    editPromo,
    fetchPromos,
    addPromo,
    deletePromo
} from './actions/promoactions';
import {
    fetchAddressfromCoords,
    fetchCoordsfromPlace,
    getDriveTime,
    getRouteDetails
} from './other/GoogleAPIFunctions';
import {
    fetchBookingLocations,
    stopLocationFetch
} from './actions/locationactions';
import {
    fetchChatMessages,
    sendMessage,
    stopFetchMessages
} from './actions/chatactions';

// import app from 'firebase/app';
import { fetchDriverEarnings } from './actions/driverearningaction';
import { fetchEarningsReport } from './actions/earningreportsaction';
import { store } from './store/store';
import firebase from 'firebase/compat/app';

const FirebaseContext = createContext(null);



const Firebase = {
   

    api: {
        MinutesPassed: MinutesPassed,
        GetDateString: GetDateString,

        fetchCoordsfromPlace: fetchCoordsfromPlace,
        fetchAddressfromCoords: fetchAddressfromCoords,
        getDriveTime: getDriveTime,
        getRouteDetails: getRouteDetails,

        GetDistance: GetDistance,
        GetTripDistance: GetTripDistance,
        saveUserLocation: (uid, location) => firebase.database().ref('users/' + uid + '/location').set(location),
        saveTracking: (bookingId, location) => firebase.database().ref('tracking/' + bookingId).push(location),

        validateReferer: validateReferer,
        checkUserExists: checkUserExists,
        checkVehicleExists: checkVehicleExists,
        checkOperatorExists: checkOperatorExists,
        fetchUser: () => (dispatch) => fetchUser()(dispatch)(firebase),
        // fetchOperator: () => (dispatch) => fetchOperator()(dispatch)(firebase),
        // fetchVehicle: () => (dispatch) => fetchVehicle()(dispatch)(firebase),
        emailSignUp: (data) => emailSignUp(data)(firebase),
        mobileSignUp: (data) => mobileSignUp(data)(firebase),
        mobileUserCreate: (data) => mobileUserCreate(data)(firebase),
        mobileCheckOtp: (data) => mobileCheckOtp(data)(firebase),
        checkOtp: (code, otp, credential) => (dispatch) => checkOtp(code, otp, credential)(dispatch)(firebase),

        mobileSignIn: (verficationId, code) => (dispatch) => mobileSignIn(verficationId, code)(dispatch)(firebase),
        updatePassword: (password) => (dispatch) => updatePassword(password)(dispatch)(firebase),
        signIn: (email, password) => (dispatch) => signIn(email, password)(dispatch)(firebase),
        facebookSignIn: (token) => (dispatch) => facebookSignIn(token)(dispatch)(firebase),
        appleSignIn: (credentialData) => (dispatch) => appleSignIn(credentialData)(dispatch)(firebase),
        signOut: () => (dispatch) => signOut()(dispatch)(firebase),
        filterDriverStatus: (email, fromdate, todate) => (dispatch) => filterDriverStatus(email, fromdate, todate)(dispatch)(firebase),
        updateProfile: (userAuthData, updateData) => (dispatch) => updateProfile(userAuthData, updateData)(dispatch)(firebase),
        updateDriverStatus: (statusData, updateData) => (dispatch) => updateDriverStatus(statusData, updateData)(dispatch)(firebase),
        monitorProfileChanges: () => (dispatch) => monitorProfileChanges()(dispatch)(firebase),
        clearLoginError: () => (dispatch) => clearLoginError()(dispatch)(firebase),
        addBooking: (bookingData) => (dispatch) => addBooking(bookingData)(dispatch)(firebase),
        addRentalBooking: (bookingData) => (dispatch) => addRentalBooking(bookingData)(dispatch)(firebase),
        editBooking: (oldbookingData, bookingData) => (dispatch) => editBooking(oldbookingData, bookingData)(dispatch)(firebase),
        clearBooking: () => (dispatch) => clearBooking()(dispatch)(firebase),
        fetchFare: () => (dispatch) => fetchFare()(dispatch)(firebase),
        deleteFare: (uid) => (dispatch) => clearFare(uid)(dispatch)(firebase),
        updateFare: (fareData) => (dispatch) => updateFare(fareData)(dispatch)(firebase),
        fetchBookings: (uid, role) => (dispatch) => fetchBookings(uid, role)(dispatch)(firebase),
        fetchAllBookings: () => (dispatch) => fetchAllBookings()(dispatch)(firebase),
        updateBooking: (booking) => (dispatch) => updateBooking(booking)(dispatch)(firebase),
        cancelBooking: (data) => (dispatch) => cancelBooking(data)(dispatch)(firebase),
        fetchCancelReasons: () => (dispatch) => fetchCancelReasons()(dispatch)(firebase),
        editCancellationReason: (reasons, method) => (dispatch) => editCancellationReason(reasons, method)(dispatch)(firebase),
        fetchCarTypes: () => (dispatch) => fetchCarTypes()(dispatch)(firebase),
        // editCarType: (carTypes, method) => (dispatch) => editCarType(carTypes, method)(dispatch)(firebase),
        editCarType: (id, carTypes) => (dispatch) => editCarType(id, carTypes)(dispatch)(firebase),
        addCarType: (carTypesData, boundary) => (dispatch) => addCarType(carTypesData, boundary)(dispatch)(firebase),
        getEstimate: (bookingData, settings) => (dispatch) => getEstimate(bookingData, settings)(dispatch)(firebase),
        clearEstimate: () => (dispatch) => clearEstimate()(dispatch)(firebase),
        getRentalEstimate: (bookingData) => (dispatch) => getRentalEstimate(bookingData)(dispatch)(firebase),
        clearRentalEstimate: () => (dispatch) => clearRentalEstimate()(dispatch)(firebase),
        clearDriverEstimate: () => (dispatch) => clearDriverEstimate()(dispatch)(firebase),
        getDriverEstimate: (bookingData) => (dispatch) => getDriverEstimate(bookingData)(dispatch)(firebase),
        fetchSettings: () => (dispatch) => fetchSettings()(dispatch)(firebase),
        editSettings: (settings) => (dispatch) => editSettings(settings)(dispatch)(firebase),
        clearSettingsViewError: () => (dispatch) => clearSettingsViewError()(dispatch)(firebase),
        sendResetMail: (email) => (dispatch) => sendResetMail(email)(dispatch)(firebase),
        fetchDriverEarnings: (uid, role) => (dispatch) => fetchDriverEarnings(uid, role)(dispatch)(firebase),
        fetchEarningsReport: () => (dispatch) => fetchEarningsReport()(dispatch)(firebase),
        fetchNotifications: () => (dispatch) => fetchNotifications()(dispatch)(firebase),
        editNotifications: (notifications) => (dispatch) => editNotifications(notifications)(dispatch)(firebase),
        addNotifications: (notifications) => (dispatch) => addNotifications(notifications)(dispatch)(firebase),
        deleteNotifications: (notifications) => (dispatch) => deleteNotifications(notifications)(dispatch)(firebase),
        sendNotification: (notification) => (dispatch) => sendNotification(notification)(dispatch)(firebase),
        fetchPromos: () => (dispatch) => fetchPromos()(dispatch)(firebase),
        addPromo: (promos) => (dispatch) => addPromo(promos)(dispatch)(firebase),
        editPromo: (promos) => (dispatch) => editPromo(promos)(dispatch)(firebase),
        deletePromo: (promos) => (dispatch) => deletePromo(promos)(dispatch)(firebase),
        fetchUsers: () => (dispatch) => fetchUsers()(dispatch)(firebase),
        fetchTransactions: () => (dispatch) => fetchTransactions()(dispatch)(firebase),
        fetchOperators: () => (dispatch) => fetchOperators()(dispatch)(firebase),
        fetchVehicles: () => (dispatch) => fetchVehicles()(dispatch)(firebase),
        fetchDriverStatus: (email, start, end) => (dispatch) => fetchDriverStatus(email, start, end)(dispatch)(firebase),
        fetchDrivers: () => (dispatch) => fetchDrivers()(dispatch)(firebase),
        addLocalFare: (faredata) => (dispatch) => addLocalFare(faredata)(dispatch)(firebase),
        addOutstationFare: (faredata) => (dispatch) => addOutstationFare(faredata)(dispatch)(firebase),
        addRentalFare: (faredata) => (dispatch) => addRentalFare(faredata)(dispatch)(firebase),
        addUser: (userdata) => (dispatch) => addUser(userdata)(dispatch)(firebase),
        uploadImage: (userdata) => (dispatch) => uploadImage(userdata)(dispatch)(firebase),
        addOperator: (operatordata) => (dispatch) => addOperator(operatordata)(dispatch)(firebase),
        addTransaction: (transdata) => (dispatch) => addTransaction(transdata)(dispatch)(firebase),
        addVehicle: (vehicledata) => (dispatch) => addVehicle(vehicledata)(dispatch)(firebase),
        addDriverStatus: (statusdata) => (dispatch) => addDriverStatus(statusdata)(dispatch)(firebase),
        editDriverStatus: (email) => (dispatch) => editDriverStatus(email)(dispatch)(firebase),
        editUser: (id, user) => (dispatch) => editUser(id, user)(dispatch)(firebase),
        editTransaction: (id, trans) => (dispatch) => editTransaction(id, trans)(dispatch)(firebase),
        editOperator: (id, operator) => (dispatch) => editOperator(id, operator)(dispatch)(firebase),
        editVehicle: (id, vehicle) => (dispatch) => editVehicle(id, vehicle)(dispatch)(firebase),
        updateVehicleCommission: (id, vehicle) => (dispatch) => updateVehicleCommission(id, vehicle)(dispatch)(firebase),
        driverCancelBooking: (data) => (dispatch) => driverCancelBooking(data)(dispatch)(firebase),
        driverEditVehicle: (id, vehicle) => (dispatch) => driverEditVehicle(id, vehicle)(dispatch)(firebase),
        updatePushToken: (userAuthData, token, platform) => (dispatch) => updatePushToken(userAuthData, token, platform)(dispatch)(firebase),
        updateProfileImage: (userAuthData, imageBlob) => (dispatch) => updateProfileImage(userAuthData, imageBlob)(dispatch)(firebase),
        requestPhoneOtpDevice: requestPhoneOtpDevice,
        // requestPhoneOtpDevice: (phoneNumber, appVerifier) => (dispatch) => requestPhoneOtpDevice(phoneNumber, appVerifier)(dispatch)(firebase),
        deleteUser: (uid) => (dispatch) => deleteUser(uid)(dispatch)(firebase),
        deleteOperator: (uid) => (dispatch) => deleteOperator(uid)(dispatch)(firebase),
        deleteTransaction: (uid) => (dispatch) => deleteTransaction(uid)(dispatch)(firebase),
        deleteVehicle: (uid, driverId) => (dispatch) => deleteVehicle(uid, driverId)(dispatch)(firebase),
        deleteCarType: (uid) => (dispatch) => deleteCarType(uid)(dispatch)(firebase),
        fetchPaymentMethods: () => (dispatch) => fetchPaymentMethods()(dispatch)(firebase),
        addToWallet: (uid, amount) => (dispatch) => addToWallet(uid, amount)(dispatch)(firebase),
        updateWalletBalance: (balance, details) => (dispatch) => updateWalletBalance(balance, details)(dispatch)(firebase),
        clearMessage: () => (dispatch) => clearMessage()(dispatch)(firebase),
        updateTripPickup: (pickupAddress) => (dispatch) => updateTripPickup(pickupAddress)(dispatch)(firebase),
        updateTripDrop: (dropAddress) => (dispatch) => updateTripDrop(dropAddress)(dispatch)(firebase),
        updateTripCar: (selectedCar) => (dispatch) => updateTripCar(selectedCar)(dispatch)(firebase),
        updatSelPointType: (selection) => (dispatch) => updatSelPointType(selection)(dispatch)(firebase),
        clearTripPoints: () => (dispatch) => clearTripPoints()(dispatch)(firebase),
        fetchTasks: () => (dispatch) => fetchTasks()(dispatch)(firebase),
        acceptTask: (userAuthData, task) => (dispatch) => acceptTask(userAuthData, task)(dispatch)(firebase),
        cancelTask: (bookingId) => (dispatch) => cancelTask(bookingId)(dispatch)(firebase),
        fetchBookingLocations: (bookingId) => (dispatch) => fetchBookingLocations(bookingId)(dispatch)(firebase),
        stopLocationFetch: (bookingId) => (dispatch) => stopLocationFetch(bookingId)(dispatch)(firebase),
        fetchChatMessages: (bookingId) => (dispatch) => fetchChatMessages(bookingId)(dispatch)(firebase),
        sendMessage: (data) => (dispatch) => sendMessage(data)(dispatch)(firebase),
        stopFetchMessages: (bookingId) => (dispatch) => stopFetchMessages(bookingId)(dispatch)(firebase),
        fetchWithdraws: () => (dispatch) => fetchWithdraws()(dispatch)(firebase),
        bookingReq: (id) => (dispatch) => bookingReq(id)(dispatch)(firebase),
        completeWithdraw: (entry) => (dispatch) => completeWithdraw(entry)(dispatch)(firebase),
        resetPassword: resetPassword,
        addCancellationReason: (reasons, method) => (dispatch) => addCancellationReason(reasons, method)(dispatch)(firebase),
        deleteCancellationReason: (id, method) => (dispatch) => deleteCancellationReason(id, method)(dispatch)(firebase),
        fetchRequestedDrivers: fetchRequestedDrivers,
        getTrackingRecord: getTrackingRecord
    }
}

// export {
//     FirebaseContext,
//     FirebaseProvider,
//     store
// }

export default Firebase;